export default __webpack_public_path__ + "static/media/enchanter.e7758e80.png";